// extracted by mini-css-extract-plugin
export var button = "styles-module--button--16a84";
export var canvas = "styles-module--canvas--60694";
export var editIcon = "styles-module--editIcon--e67ed";
export var image = "styles-module--image--c93e8";
export var label = "styles-module--label--d9b5a";
export var pointer = "styles-module--pointer--e382b";